import AbstractContext from "../../shared/AbstractContext";
import AbstractSession from "../../shared/session/AbstractSession";
import AbstractTokenHandler from "../../shared/session/token/AbstractTokenHandler";

export default class AdminTokenHandler<C extends AbstractContext<C, S>, S extends AbstractSession<C, S>>
	extends AbstractTokenHandler<C, S> {

	protected async clear(): Promise<void> {
		let session: S = this.context.session;

		// clear login leftovers
		await session.clearSessionToken();
		this.context.getPage().setState({
			showAdminLoginDialog: true,
			adminLoginParameter: undefined
		});
	}
}